import { useDynamicPrices } from 'contexts/hooks/useDynamicPrices'
import { useMemo } from 'react'
import { Edition } from 'utils/data'

interface Config {
  edition: Edition | undefined | null
}

/**
 * Picks the right prices for the edition, based on the user's region and currency.
 *
 * The prices are in DOLLARS/EURO/POUNDS, NOT CENTS.
 */
export function useEditionPrices({ edition }: Config) {
  const { pricePicker } = useDynamicPrices()

  return useMemo(() => {
    const prices = pricePicker.fromEditionAttributes(edition)

    return {
      ...prices,
      highestBid: prices.highestBid || 0,
      highestBidGbp: prices.highestBidGbp || 0,
      lowestAsk: prices.lowestAsk || 0,
      lowestAskGbp: prices.lowestAskGbp || 0,
    }
  }, [edition, pricePicker])
}
